// import polyfills for modern target
import 'dom4';
import svg4everybody from 'svg4everybody';
import picturefill from 'picturefill';

svg4everybody();
picturefill();
